export default "__VITE_ASSET__6531f54b__"